import { t } from './i18n/index.js';
import { S } from './state.js';

export const p2=n=>String(n).padStart(2,'0');
export const dstr=d=>d.getFullYear()+'-'+p2(d.getMonth()+1)+'-'+p2(d.getDate());
export const today=()=>dstr(new Date());
export function fromD(s){const[a,b,c]=s.split('-').map(Number);return new Date(a,b-1,c)}
export function addDays(s,n){const d=fromD(s);d.setDate(d.getDate()+n);return dstr(d)}
export function diffDays(a,b){return Math.round((fromD(b)-fromD(a))/864e5)}
export function dow(s){return fromD(s).getDay()} // 0=Sun
export function isoDow(s){const d=dow(s);return d===0?7:d} // 1=Mon..7=Sun
export function startOfWeek(s){return addDays(s,1-isoDow(s))}
export function startOfMonth(s){return s.slice(0,8)+'01'}
export function loc(){return {en:'en-GB',de:'de-DE',fr:'fr-FR'}[S.settings.lang]||'en-GB'}
export function fmtDate(s,opts){return fromD(s).toLocaleDateString(loc(),opts||{day:'numeric',month:'short',year:'numeric'})}
export function fmtDateLong(s){return fromD(s).toLocaleDateString(loc(),{weekday:'long',day:'numeric',month:'long'})}
export function fmtDM(s){return fromD(s).toLocaleDateString(loc(),{day:'numeric',month:'short'})}
export function fmtMonthYear(s){return fromD(s).toLocaleDateString(loc(),{month:'long',year:'numeric'})}
export function wdShort(i){const base=fromD('2024-01-01');base.setDate(base.getDate()+i-1);return base.toLocaleDateString(loc(),{weekday:'short'})} // i:1=Mon
export function minToHM(m){return p2(Math.floor(m/60))+':'+p2(m%60)}
export function hmToMin(hm){const[a,b]=hm.split(':').map(Number);return a*60+(b||0)}
export function fmtH(mins){const h=mins/60;return (Math.round(h*100)/100).toLocaleString(loc(),{maximumFractionDigits:2})+' '+t('c.h')}
export function nthOfMonth(s){return Math.ceil(fromD(s).getDate()/7)}

/* ---------- money ---------- */
export function money(v){return new Intl.NumberFormat(loc(),{style:'currency',currency:S.settings.currency}).format(v||0)}

/* ---------- students ---------- */
